export const Support = {
  PHONE_NUMBER: 'tel:+18773778276',
  SUPPORT_LINK: 'https://support.varomoney.com/hc/en-us',
  SUPPORT_TICKET_LINK:
    'https://support.varomoney.com/hc/en-us/requests/new?ticket_form_id=18705169315604',
};
